import React from 'react';
import styles from './styles.module.scss';

const SectionHeader = ({ tagline, valueprop, subtext }) => (
  <div className={styles.sectionHeader}>
    <h5>{tagline}</h5>
    <h2>{valueprop}</h2>
    {subtext && (
      <p>{subtext}</p>
    )}
  </div>
);

export default SectionHeader;
